/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  Object Strucutre:
                    path => router path
                    name => router name
                    component(lazy loading) => component to load
                    meta : {
                      rule => which user can have access (ACL) d
                      pageTitle => 
                    }
  ----------------------------------------------------------------------------------------

==========================================================================================*/



import Vue from 'vue'
import Router from 'vue-router'
import AuthService from '../services/auth'
//import { Trans } from '../plugins/Translation.js'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    linkActiveClass: 'active',
    routes: [

        {
           path: '',
            //component: () => import('../views/auth/Login.vue'),
            component: () => import('../views/auth/Login.vue'),
            name:'login'
           // beforeEnter: Trans.routeMiddleware
       
        },
        {
            path: '/verifyCode',
             //component: () => import('../views/auth/Login.vue'),
             component: () => import('../views/auth/VerifyCode.vue'),
             name:'VerifyCode',
             meta: { requiresAuth: true }
            // beforeEnter: Trans.routeMiddleware
        
         },

        {
          path: '/',
          component: () => import('../views/layouts/LayoutHorizontal.vue'),
          //component: () => import('../views/layouts/LayoutHorizontal.vue'),
          meta: { requiresAuth: true },
          children: [
              {
                  path: 'home/:id',
                  component:() => import('../views/home/Dashboard.vue'),
                  name: 'home',
                  props: true,
               
              }
           ]
          }
        
        // Redirect to 404 page, if no match found
        
    ],
})
/*
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }
})

router.beforeEach((to, from, next) => {
    firebase.auth().onAuthStateChanged(() => {

        // get firebase current user
        const firebaseCurrentUser = firebase.auth().currentUser;

        if (
            to.path === "/pages/login" ||
            to.path === "/pages/forgot-password" ||
            to.path === "/pages/error-404" ||
            to.path === "/pages/error-500" ||
            to.path === "/pages/register" ||
            to.path === "/callback" ||
            to.path === "/pages/comingsoon" ||
            (auth.isAuthenticated() || firebaseCurrentUser)
        ) {
            return next();
        }

        router.push({ path: '/pages/login', query: { to: to.path } })
        // Specify the current path as the customState parameter, meaning it
        // will be returned to the application after auth
        // auth.login({ target: to.path });

    });

});*/

router.beforeEach((to, from, next) => {
    //  If the next route is requires user to be Logged IN

    if (to.matched.some(m => m.meta.requiresAuth)) {
        console.log("--munsmr----");
        
       
        console.log();
        var isVerifyPath=to.path === "/verifyCode" && AuthService.isLogin()
        console.log("isVerifyPath"+isVerifyPath);
        console.log("AuthService.isLoginVerfied()"+AuthService.isLoginVerfied());
               
        if(isVerifyPath&&(AuthService.isLoginVerfied()==='false')) {
           return  next(); 
        }

            
          if (AuthService.isLoginVerfied()=='true') {
           return next(); 
        } else  {
            next({ name: 'login' })
        } 

    } else {

        return next()
    }
})

export default router
